import { getRgObjectsOfType as g, RG_TYPE as d } from "@project-rouge/rg-core";
import { getPivot as f } from "../../../geometry-utils/three/index12.js";
const m = (l) => {
  let e = 0;
  const n = g(l, d.Building);
  for (const i of n) {
    const o = i.data.levels.filter((t) => t.isRoof).sort((t, s) => s.levelIndex - t.levelIndex).at(0);
    if (!o)
      continue;
    const a = i.children.filter((t) => t.data.levelId === o.uuid), r = Math.max(...a.map((t) => f([0.5, 1, 0.5], t).y));
    e = Math.max(e, r);
  }
  return e;
};
export {
  m as getMaxHeight
};
//# sourceMappingURL=index34.js.map
